import { useTranslator } from 'tradera-lang/translate';
import React from 'react';
import { formatNumberWithSeparators } from '@tradera/blueprint/utils';

export const Summary = ({ model }) => {
    const { t } = useTranslator();
    if (model.hasFeedbackItems) {
        return (
            <table className="profile-page-feedback-summary-table">
                <thead>
                    <tr>
                        <th className="text-left">
                            {t('profileRating_ratings')}
                        </th>
                        <th className="text-center text-positive max-width-col">
                            {t('profileRating_positive')}
                        </th>
                        <th className="text-center text-negative max-width-col">
                            {t('profileRating_negative')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{t('profileRating_lastMonth')}</td>
                        <td className="text-center text-positive">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember.lastMonth
                                    .totalPositive
                            )}
                        </td>
                        <td className="text-center text-negative">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember.lastMonth
                                    .totalNegative
                            )}
                        </td>
                    </tr>

                    <tr>
                        <td>{t('profileRating_lastSixMonths')}</td>
                        <td className="text-center text-positive">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember
                                    .lastSixMonths.totalPositive
                            )}
                        </td>
                        <td className="text-center text-negative">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember
                                    .lastSixMonths.totalNegative
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>{t('profileRating_lastTwelveMonths')}</td>
                        <td className="text-center text-positive">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember
                                    .lastTwelveMonths.totalPositive
                            )}
                        </td>
                        <td className="text-center text-negative">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember
                                    .lastTwelveMonths.totalNegative
                            )}
                        </td>
                    </tr>

                    <tr>
                        <td>{t('profileRating_sinceRegistration')}</td>
                        <td className="text-center text-positive">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember
                                    .sinceRegistration.totalPositive
                            )}
                        </td>
                        <td className="text-center text-negative">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember
                                    .sinceRegistration.totalNegative
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>{t('profileRating_uniqueRatingsCount')}</td>
                        <td className="text-center text-positive">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember.unique
                                    .totalPositive
                            )}
                        </td>
                        <td className="text-center text-negative">
                            {formatNumberWithSeparators(
                                model.totalFeedbackSummaryForMember.unique
                                    .totalNegative
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    return (
        <div className="profile-page-empty">
            <p>
                <b>{t('profileRating_noRatings')}</b>
            </p>
        </div>
    );
};
